import { render } from "./Trames.vue?vue&type=template&id=e1daf2ce"
import script from "./Trames.vue?vue&type=script&lang=js"
export * from "./Trames.vue?vue&type=script&lang=js"

import "./Trames.vue?vue&type=style&index=0&id=e1daf2ce&lang=css"

import exportComponent from "/var/www/extranet-sinistre-agemi/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__